/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* Generate a table of contents for post headings */
(function () {
    if (!document.body.classList.contains('post-template')) return;

    const content = document.querySelector('.gh-content');
    const tocContainer = document.querySelector('[data-toc]');
    if (!content || !tocContainer) return;

    const headings = Array.from(content.querySelectorAll('h2, h3'))
        .filter(function (heading) {
            return heading.textContent && heading.textContent.trim();
        });

    if (headings.length < 3) return;

    const idsInUse = new Set(
        Array.from(content.querySelectorAll('[id]'))
            .map(function (element) {
                return element.id;
            })
            .filter(Boolean)
    );

    const toSlug = function (value) {
        return value
            .toLowerCase()
            .trim()
            .replace(/&/g, ' and ')
            .replace(/[^a-z0-9\s-]/g, '')
            .replace(/\s+/g, '-')
            .replace(/-+/g, '-')
            .replace(/^-|-$/g, '') || 'section';
    };

    headings.forEach(function (heading) {
        if (heading.id) return;

        const baseSlug = toSlug(heading.textContent);
        let slug = baseSlug;
        let suffix = 2;

        while (idsInUse.has(slug)) {
            slug = baseSlug + '-' + suffix;
            suffix += 1;
        }

        heading.id = slug;
        idsInUse.add(slug);
    });

    const groups = [];
    let currentGroup = null;

    headings.forEach(function (heading) {
        if (heading.tagName === 'H2') {
            currentGroup = {
                heading,
                children: [],
            };
            groups.push(currentGroup);
            return;
        }

        if (!currentGroup) {
            currentGroup = {
                heading: null,
                children: [],
            };
            groups.push(currentGroup);
        }

        currentGroup.children.push(heading);
    });

    const list = document.createElement('ul');
    list.className = 'gh-toc-list';

    const buildChildList = function (childHeadings) {
        const childList = document.createElement('ul');
        childList.className = 'gh-toc-children';

        childHeadings.forEach(function (heading) {
            const childItem = document.createElement('li');
            childItem.className = 'gh-toc-item gh-toc-item--h3';

            const childLink = document.createElement('a');
            childLink.className = 'gh-toc-link';
            childLink.href = '#' + heading.id;
            childLink.textContent = heading.textContent.trim();

            childItem.appendChild(childLink);
            childList.appendChild(childItem);
        });

        return childList.childNodes.length ? childList : null;
    };

    let openedFirstMultiAccordion = false;

    groups.forEach(function (group) {
        if (!group.heading) {
            group.children.forEach(function (heading) {
                const childItem = document.createElement('li');
                childItem.className = 'gh-toc-item gh-toc-item--h3';

                const childLink = document.createElement('a');
                childLink.className = 'gh-toc-link';
                childLink.href = '#' + heading.id;
                childLink.textContent = heading.textContent.trim();

                childItem.appendChild(childLink);
                list.appendChild(childItem);
            });
            return;
        }

        const childList = buildChildList(group.children);
        const item = document.createElement('li');
        item.className = 'gh-toc-item gh-toc-item--h2';

        const h2Link = document.createElement('a');
        h2Link.className = 'gh-toc-link gh-toc-link--h2';
        h2Link.href = '#' + group.heading.id;
        h2Link.textContent = group.heading.textContent.trim();

        if (group.children.length >= 2 && childList) {
            item.classList.add('gh-toc-item--has-accordion');
            const details = document.createElement('details');
            details.className = 'gh-toc-details';
            if (!openedFirstMultiAccordion) {
                details.open = true;
                openedFirstMultiAccordion = true;
            }

            const summary = document.createElement('summary');
            summary.className = 'gh-toc-summary';
            summary.appendChild(h2Link);

            details.appendChild(summary);
            details.appendChild(childList);
            item.appendChild(details);
        } else if (childList) {
            const titleRow = document.createElement('div');
            titleRow.className = 'gh-toc-h2-row';
            titleRow.appendChild(h2Link);
            item.appendChild(titleRow);
            item.appendChild(childList);
        } else {
            const titleRow = document.createElement('div');
            titleRow.className = 'gh-toc-h2-row';
            titleRow.appendChild(h2Link);
            item.appendChild(titleRow);
        }

        list.appendChild(item);
    });

    const title = document.createElement('h2');
    title.className = 'gh-toc-title';
    title.id = 'table-of-contents-heading';
    title.textContent = 'Table of contents';

    tocContainer.appendChild(title);
    tocContainer.appendChild(list);

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const scrollBehavior = prefersReducedMotion ? 'auto' : 'smooth';

    /* Capture: smooth-scroll TOC links and stop toggle on <details><summary> rows */
    tocContainer.addEventListener(
        'click',
        function (event) {
            const link = event.target.closest('.gh-toc-link');
            if (!link || !tocContainer.contains(link)) return;

            const targetId = link.getAttribute('href');
            if (!targetId || !targetId.startsWith('#')) return;

            const heading = document.querySelector(targetId);
            if (!heading) return;

            event.preventDefault();
            event.stopPropagation();
            heading.scrollIntoView({
                behavior: scrollBehavior,
                block: 'start',
            });
            history.replaceState(null, '', targetId);
        },
        true
    );

    tocContainer.hidden = false;
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();